<template>
  <div v-if="message" id="popup-modal" data-modal-placement="center" tabindex="-1" class="flex justify-center items-center h-full overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 bg-black/90 justify-center items-center w-full md:inset-0 max-h-full z-[100]" :class="show ? 'flex' : 'hidden'">
    <div class="relative p-4 w-full max-w-md max-h-full">
      <div class="md:w-[508px] w-[98%] relative bg-black/[.86] border border-brand-green/[0.3] shadow">
        <button @click="show = false" type="button" class="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-hide="popup-modal">
          <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
        <div class="p-4 md:p-[72px] text-center p-[30px]">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" class="m-auto">
            <path d="M24 4C13 4 4 13 4 24C4 35 13 44 24 44C35 44 44 35 44 24C44 13 35 4 24 4ZM20 34L10 24L12.82 21.18L20 28.34L35.18 13.16L38 16L20 34Z" fill="white"/>
          </svg>
          <h3 class="mt-7 mb-3 text-2xl font-normal">{{ message.header }}</h3>
          <p class="mb-12 text-[14px] leading-[140%] opacity-50">{{ message.text }}</p>
          <button @click="show = false" data-modal-hide="popup-modal" type="button" class="w-[190px] justify-center px-4 py-3 mt-4 group text-xl font-semibold hover:opacity-80 text-black font-mono bg-brand-green border border-brand-green hover:border-brand-green hover:text-brand-green hover:bg-brand-gray-700 hover:cursor-pointer group">
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { onMounted, toRefs } from "vue";

export default {
  props: {
    message: {
      type: Object,
      default: () => null,
    },
  },
  setup(props) {
    const { message } = toRefs(props);

    onMounted(() => {
      if(typeof window.lintrk !== "undefined"  && message){
        try {
          window.lintrk('track', { conversion_id: 16469641 });
        }catch (e) {
          console.log(e);
        }
      }
    });
  },
  data() {
    return {
      show: true,
    };
  },
};
</script>
